import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import ActionPermissionGuard from "shared/components/utils/ActionPermissionGuard";
import GridContext from "features/allocations/contexts/Context";
import SelectRows from "./SelectRows";
import moment from "moment";
import {
    Wrapper,
    IndentColumn,
    Column,
    ItemColum,
    ItemColumLabel,
} from "./Header.styles";

const getColumnLabels = (gridStartDate, columnCount) => {
    if (!gridStartDate) {
        return null;
    }
    let columnsHeaders = [];
    for (let i = 1; i <= columnCount; i++) {
        const startDate = moment(gridStartDate).add((i - 1) * 7, "days");
        const endDate = moment(startDate).add(6, "days");
        let week = "";
        if (moment(startDate).format("MMM") === moment(endDate).format("MMM")) {
            week = `${moment(startDate).format("MMM D")}-${moment(endDate).format("D")}`;
        } else {
            week = `${moment(startDate).format("MMM D")} - ${moment(endDate).format("MMM D")}`;
        }
        columnsHeaders.push({ description: week });
    }
    return columnsHeaders;
};

const Header = ({
    _columns,
    _onSelect,
    _onSelectAll,
    _onEnableRowsSelection,
    ..._selectionHandler
}) => {
    const { gridParams, columnsView } = useContext(GridContext);
    const [columnLabels, setColumnLabels] = useState(null)

    useEffect(() => {
        setColumnLabels(getColumnLabels(gridParams.dateFrom, columnsView));
    }, [gridParams.dateFrom, gridParams.dateTo, columnsView])

    return (
        <Wrapper id="date_cols_wrapper">
                <IndentColumn xs={1} />
                <Column xs={4} lg={3}>
                    <ActionPermissionGuard code="AC_SELECT_MULTIPLE_EMP"><SelectRows /></ActionPermissionGuard>
                </Column>
                {columnLabels?.map((column) =>
                     (
                        <ItemColum key={column.description}>
                            <ItemColumLabel>{column.description}</ItemColumLabel>
                        </ItemColum>
                    )
                )}
                <IndentColumn xs={1} />
        </Wrapper>
    );
};

Header.propTypes = {
    _columns: PropTypes.array,
    _onSelect: PropTypes.func,
    _onSelectAll: PropTypes.func,
    _onEnableRowsSelection: PropTypes.func,
};

export default Header;
